var map = {
	"./cnn-money-x2.png": 2061,
	"./economist-x2.png": 2062,
	"./mashable-x2.png": 2063,
	"./tech-crunch-x2.png": 2064,
	"./thenewyorker-x2.png": 2065,
	"./thrillist-x2.png": 2066,
	"./time-x2.png": 2067,
	"./usa-today-x2.png": 2068
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2282;